/**
 * footer
 */
// Module dependencies
import 'protons';
// Module template
import './_footer.twig';
import './_footer.css';

export const name = 'footer';
export function disable() {}
export function enable() {}
export default enable;
